(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('ConfigDialogController', ConfigDialogController);

    ConfigDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Config', 'DateUtils'];

    function ConfigDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Config, DateUtils) {
        var vm = this;

        vm.config = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.config.id !== null) {
                Config.update(vm.config, onSaveSuccess, onSaveError);
            } else {
                Config.save(vm.config, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            // Si on a modifié la période de paie, on invalide le cache du DateUtils
            // pour que la nouvelle valeur soit relue au prochain calcul de période.
            if (result && result.name === 'payroll_cutoff_day') {
                DateUtils.invalidateCutoffDay();
            }
            $scope.$emit('tmgApp:configUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
